"use strict";

import gsap from "gsap";
import CustomEase from "gsap/CustomEase";

const studyLeaveAnimation = (container) => {
	gsap.registerPlugin(CustomEase);

	const tl = gsap.timeline();

	const info = container.querySelectorAll(".proj-info ul");
	const title = container.querySelector(".title");
	const image = container.querySelector(".main-image");
	const content = container.querySelectorAll(".content > *");

	const compDuration = 0.6 / content.length;

	tl.to(info, { stagger: -0.1, xPercent: 400, duration: 0.6, ease: "power4.in" })
		.to(info, { stagger: -0.1, opacity: 0, duration: 0.4, ease: "none" }, "<")
		.to(title, { xPercent: -200, duration: 0.6, ease: "power4.in" }, 0)
		.to(title, { opacity: 0, duration: 0.4, ease: "none" }, "<")
		.to(image, { xPercent: 80, duration: 0.6, ease: "power4.in" }, 0)
		.to(image, { opacity: 0, duration: 0.4, ease: "none" }, "<")
		.to(
			content,
			{ stagger: 0.05, duration: compDuration, xPercent: -100, ease: "power4.in" },
			0
		)
		.to(content, { stagger: 0.05, opacity: 0, duration: 0.01, ease: "none" }, "<");

	return tl;
};

export default studyLeaveAnimation;
